import { Component, ViewChild } from '@angular/core';
import { MatPaginator as MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource as MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TranslateHelper } from '@app/_helpers';
import { AuthenticationService } from '@app/_services';
import { QuotationCartService } from '@app/_services/quotation.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { RouterLink } from '@angular/router';
import { NgIf, DatePipe } from '@angular/common';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'app-active-quotations',
    templateUrl: './active-quotations.component.html',
    styleUrls: ['./active-quotations.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [FlexModule, NgIf, MatTableModule,MatFormFieldModule, RouterLink, DatePipe, TranslateModule, MatPaginatorModule, MatInputModule]
})
export class ActiveQuotationsComponent {
    userDetails;
    items: any;
    constructor(private authService: AuthenticationService, public quotationCart: QuotationCartService,
        private toastr: ToastrService, public translate: TranslateService,
        public translateHelper: TranslateHelper
        ) {}

    displayedColumns: string[] = ['id', 'company', 'date', 'lastUpdatedDate', 'total', 'status'];
    dataSource: MatTableDataSource<any>;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    ngOnInit(): void {
        this.authService.currentUser.subscribe((user): any => {
            this.userDetails = user;
        });
        this.loadQuotations();
    }

    status = {
        new: {
            color: '#125077',
            text: 'New',
        },
        open: {
            color: '#9E6DEB',
            text: 'Open',
        },
        offered: {
            color: '#ff5900',
            text: 'Offered',
        },
        accepted: {
            color: '#079008',
            text: 'Accepted',
        },
        inprogress: {
            color: '#6D9EEB',
            text: 'In-Progress',
        },
        rejected: {
            color: '#ff0202',
            text: 'Rejected',
        },

        cancelled: {
            color: '#ff0202',
            text: 'Cancelled',
        },
        renegotiated: {
            color: '#0095a0',
            text: 'Renegotiated',
        },
    };

    loadQuotations() {
        this.dataSource = new MatTableDataSource;
        this.dataSource.data = [];
        this.quotationCart.getActiveQuotations() .subscribe(data=>{
            if(data?.data)
            this.dataSource.data = data.data;
            else
            this.toastr.error('Error getting Data');
        }, (error)=>{
            console.error(error);
        });
    }
    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }
}
